<template>
  <div>
    <el-menu :default-active="currentPath"
             style="border: 0;" active-text-color="#ed7403"
             :default-openeds="menuIds"
             router
    >
      <menu-item v-for="(item) in menus" :key="item.id" :item="item"/>
    </el-menu>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance, computed} from 'vue';
import api from '@/api/request';
import {createTree} from "@/utils/trees";
import { useRouter } from 'vue-router';
import MenuItem from "@/components/menu/MenuItem";
import {useAuthStore} from "@/store/auth";
import {useRouterStore} from "@/store/router";

export default {
  name: "Menu",
  components: {
    MenuItem
  },
  setup() {
    const router = useRouter();
    const routerStore = useRouterStore()

    const currentPath = computed(() => router.currentRoute.value.path)
    const menus = computed(() => {return routerStore.menus})
    const menuIds = ref(['1801542011643650048', '1801542190186782720'])
    
    const fetchMenu = async () => {
      try {
        const response = await api.post('/user-center-server/sys_user/current_user_info')
        routerStore.setMenus(createTree(response.data.menuList.filter(item => item.activeFlag === true)))
        const authStore = useAuthStore();
        authStore.setUser({
          nickName: response.data.userInfo.nickName,
          tenantNo: response.data.userInfo.tenantNo,
        })
      } catch (error) {
        console.log(error)
      }
    }

    onMounted(fetchMenu)

    return {
      currentPath, menus, menuIds
    }
  }
}
</script>

<style lang="scss" scoped>



</style>